
export let games = [
    {
      "Week": "Superbowl",
      "Date": "2/12/2023",
      "HomeTeam": "PHI",
      "xValues": [9,2,4,6,5,7,1,8,0,3],
      "AwayTeam": "KC",
      "Channel": "FOX",
      "pot": "250",
      "Time": "6:30PM",
      "yValues": [1,0,4,3,5,8,6,2,7,9],
      "newSquareData": [],
      "finalScore": {
        "HomeTeam": "N/A",
        "AwayTeam": "N/A"
      }
    }];
    export const squares = 
    [
        {
          "id": 1,
          "0": "DEGREE",
          "1": "JOE",
          "2": "CHAD",
          "3": "ZEVA",
          "4": "RAY",
          "5": "MILES",
          "6": "VANESSA",
          "7": "ETHRIDGE",
          "8": "RICK",
          "9": "BOCK",
        },
        {
          "id": 2,
          "0": "AMODIO",
          "1": "ERIK",
          "2": "ZIVIC",
          "3": "LAURA",
          "4": "ZEVA",
          "5": "JOE",
          "6": "CARR",
          "7": "RICK",
          "8": "JP",
          "9": "ZEVA",
        },
        {
          "id": 3,
          "0": "VANESSA",
          "1": "BOCK",
          "2": "BIGA",
          "3": "MILES",
          "4": "GRAY",
          "5": "MARKO",
          "6": "SOMMERS",
          "7": "ETHRIDGE",
          "8": "HAWSE",
          "9": "CARR",
        },
        {
          "id": 4,
          "0": "PAIGE",
          "1": "MARKKO",
          "2": "DEGREE",
          "3": "NOONAN",
          "4": "TIDWELL",
          "5": "ZEVA",
          "6": "VANESSA",
          "7": "DEGREE",
          "8": "BIGA",
          "9": "ERIC",
        },
        {
          "id": 5,
          "0": "LAURA",
          "1": "BELLE",
          "2": "BOCK",
          "3": "NOONAN",
          "4": "ZIVIC",
          "5": "DJ",
          "6": "RAY",
          "7": "JOE",
          "8": "RAY",
          "9": "BOCK",
        },
        {
          "id": 6,
          "0": "PAIGE",
          "1": "MILES",
          "2": "ETHRIDGE",
          "3": "JP",
          "4": "SOMMERS",
          "5": "BELLE",
          "6": "GRAY",
          "7": "SOMMERS",
          "8": "HAWSE",
          "9": "CARR",
        },
        {
          "id": 7,
          "0": "PAIGE",
          "1": "MARKO",
          "2": "NOONAN",
          "3": "BELLE",
          "4": "TIDWELL",
          "5": "DEGREE",
          "6": "BIGA",
          "7": "ERIK",
          "8": "TIDWELL",
          "9": "JP",
        },
        {
          "id": 8,
          "0": "LAURA",
          "1": "VANESSA",
          "2": "RICK",
          "3": "ZIVIC",
          "4": "CHAD",
          "5": "NANA",
          "6": "CURTIS",
          "7": "JOE",
          "8": "RAY",
          "9": "MILES",
        },
        {
          "id": 9,
          "0": "ETHRIDGE",
          "1": "GRAY",
          "2": "JP",
          "3": "GRAY",
          "4": "SOMMERS",
          "5": "HAWSE",
          "6": "CARR",
          "7": "PAIGE",
          "8": "MARKO",
          "9": "NANA",
        },
        {
          "id": 0,
          "0": "NOONAN",
          "1": "BELLE",
          "2": "TIDWELL",
          "3": "AMODIO",
          "4": "DEGREE",
          "5": "BIGA",
          "6": "ERIK",
          "7": "LAURA",
          "8": "RICK",
          "9": "ZIVIC",
        }
       ]
    export const squares2 = 
    [
        {
          "id": 1,
          "0": "",
          "1": "",
          "2": "",
          "3": "",
          "4": "",
          "5": "",
          "6": "",
          "7": "",
          "8": "",
          "9": "",
        },
        {
          "id": 2,
          "0": "AMODIO",
          "1": "ERIK",
          "2": "ZIVIC",
          "3": "LAURA",
          "4": "",
          "5": "JOE",
          "6": "CARR",
          "7": "RICK",
          "8": "",
          "9": "",
        },
        {
          "id": 3,
          "0": "VANESSA",
          "1": "",
          "2": "BIGA",
          "3": "MILES",
          "4": "",
          "5": "MARKO",
          "6": "",
          "7": "ETHRIDGE",
          "8": "",
          "9": "",
        },
        {
          "id": 4,
          "0": "",
          "1": "",
          "2": "DEGREE",
          "3": "",
          "4": "",
          "5": "ZEVA",
          "6": "",
          "7": "",
          "8": "",
          "9": "",
        },
        {
          "id": 5,
          "0": "",
          "1": "BELLE",
          "2": "",
          "3": "NOONAN",
          "4": "",
          "5": "",
          "6": "RAY",
          "7": "",
          "8": "",
          "9": "BOCK",
        },
        {
          "id": 6,
          "0": "PAGE",
          "1": "",
          "2": "",
          "3": "",
          "4": "SOMMERS",
          "5": "",
          "6": "",
          "7": "",
          "8": "",
          "9": "",
        },
        {
          "id": 7,
          "0": "",
          "1": "",
          "2": "",
          "3": "",
          "4": "",
          "5": "",
          "6": "",
          "7": "",
          "8": "TIDWELL",
          "9": "JP",
        },
        {
          "id": 8,
          "0": "",
          "1": "",
          "2": "",
          "3": "",
          "4": "",
          "5": "",
          "6": "CURTIS",
          "7": "",
          "8": "",
          "9": "",
        },
        {
          "id": 9,
          "0": "",
          "1": "GRAY",
          "2": "",
          "3": "",
          "4": "",
          "5": "",
          "6": "",
          "7": "",
          "8": "",
          "9": "NANA",
        },
        {
          "id": 0,
          "0": "",
          "1": "",
          "2": "",
          "3": "",
          "4": "",
          "5": "",
          "6": "",
          "7": "",
          "8": "",
          "9": "",
        }
       ]
export let games1 = [
  {
      "Week": 1,
      "newSquareData": [
          {
              "0": "0",
              "1": "2",
              "2": "3",
              "3": "1",
              "4": "5",
              "5": "4",
              "6": "7",
              "7": "9",
              "8": "6",
              "9": "8",
              "id": 0
          },
          {
              "0": "0",
              "1": "2",
              "2": "3",
              "3": "1",
              "4": "5",
              "5": "4",
              "6": "7",
              "7": "9",
              "8": "6",
              "9": "8",
              "id": 3
          },
          {
              "0": "0",
              "1": "2",
              "2": "3",
              "3": "1",
              "4": "5",
              "5": "4",
              "6": "7",
              "7": "9",
              "8": "6",
              "9": "8",
              "id": 1
          },
          {
              "0": "0",
              "1": "2",
              "2": "3",
              "3": "1",
              "4": "5",
              "5": "4",
              "6": "7",
              "7": "9",
              "8": "6",
              "9": "8",
              "id": 2
          },
          {
              "0": "0",
              "1": "2",
              "2": "3",
              "3": "1",
              "4": "5",
              "5": "4",
              "6": "7",
              "7": "9",
              "8": "6",
              "9": "8",
              "id": 5
          },
          {
              "0": "0",
              "1": "2",
              "2": "3",
              "3": "1",
              "4": "5",
              "5": "4",
              "6": "7",
              "7": "9",
              "8": "6",
              "9": "8",
              "id": 4
          },
          {
              "0": "0",
              "1": "2",
              "2": "3",
              "3": "1",
              "4": "5",
              "5": "4",
              "6": "7",
              "7": "9",
              "8": "6",
              "9": "8",
              "id": 8
          },
          {
              "0": "0",
              "1": "2",
              "2": "3",
              "3": "1",
              "4": "5",
              "5": "4",
              "6": "7",
              "7": "9",
              "8": "6",
              "9": "8",
              "id": 6
          },
          {
              "0": "0",
              "1": "2",
              "2": "3",
              "3": "1",
              "4": "5",
              "5": "4",
              "6": "7",
              "7": "9",
              "8": "6",
              "9": "8",
              "id": 9
          },
          {
              "0": "0",
              "1": "2",
              "2": "3",
              "3": "1",
              "4": "5",
              "5": "4",
              "6": "7",
              "7": "9",
              "8": "6",
              "9": "8",
              "id": 7
          }
      ],
      "Date": "09/12/22",
      "finalScore": {
          "HomeTeam": "17",
          "AwayTeam": "16"
      },
      "Channel": "ESPN/ABC",
      "pot": "",
      "Time": "8:15pm",
      "HomeTeam": "SEA",
      "yValues": [
          0,
          3,
          1,
          2,
          5,
          4,
          8,
          6,
          9,
          7
      ],
      "xValues": [
          9,
          7,
          3,
          4,
          6,
          2,
          0,
          5,
          1,
          8
      ],
      "AwayTeam": "DEN"
  },
  {
      "newSquareData": [
          {
              "0": "1",
              "1": "7",
              "2": "0",
              "3": "4",
              "4": "9",
              "5": "2",
              "6": "8",
              "7": "3",
              "8": "6",
              "9": "5",
              "id": 2
          },
          {
              "0": "1",
              "1": "7",
              "2": "0",
              "3": "4",
              "4": "9",
              "5": "2",
              "6": "8",
              "7": "3",
              "8": "6",
              "9": "5",
              "id": 0
          },
          {
              "0": "1",
              "1": "7",
              "2": "0",
              "3": "4",
              "4": "9",
              "5": "2",
              "6": "8",
              "7": "3",
              "8": "6",
              "9": "5",
              "id": 5
          },
          {
              "0": "1",
              "1": "7",
              "2": "0",
              "3": "4",
              "4": "9",
              "5": "2",
              "6": "8",
              "7": "3",
              "8": "6",
              "9": "5",
              "id": 7
          },
          {
              "0": "1",
              "1": "7",
              "2": "0",
              "3": "4",
              "4": "9",
              "5": "2",
              "6": "8",
              "7": "3",
              "8": "6",
              "9": "5",
              "id": 3
          },
          {
              "0": "1",
              "1": "7",
              "2": "0",
              "3": "4",
              "4": "9",
              "5": "2",
              "6": "8",
              "7": "3",
              "8": "6",
              "9": "5",
              "id": 9
          },
          {
              "0": "1",
              "1": "7",
              "2": "0",
              "3": "4",
              "4": "9",
              "5": "2",
              "6": "8",
              "7": "3",
              "8": "6",
              "9": "5",
              "id": 8
          },
          {
              "0": "1",
              "1": "7",
              "2": "0",
              "3": "4",
              "4": "9",
              "5": "2",
              "6": "8",
              "7": "3",
              "8": "6",
              "9": "5",
              "id": 1
          },
          {
              "0": "1",
              "1": "7",
              "2": "0",
              "3": "4",
              "4": "9",
              "5": "2",
              "6": "8",
              "7": "3",
              "8": "6",
              "9": "5",
              "id": 6
          },
          {
              "0": "1",
              "1": "7",
              "2": "0",
              "3": "4",
              "4": "9",
              "5": "2",
              "6": "8",
              "7": "3",
              "8": "6",
              "9": "5",
              "id": 4
          }
      ],
      "Time": "8:30pm",
      "finalScore": {
          "HomeTeam": "A",
          "AwayTeam": "A"
      },
      "Week": 2,
      "Date": "09/19/22",
      "xValues": [
          8,
          9,
          6,
          4,
          3,
          2,
          5,
          1,
          7,
          0
      ],
      "AwayTeam": "MIN",
      "HomeTeam": "PHI",
      "Channel": "ABC",
      "pot": "",
      "yValues": [
          2,
          0,
          5,
          7,
          3,
          9,
          8,
          1,
          6,
          4
      ]
  },
  {
      "newSquareData": [
          {
              "0": "1",
              "1": "9",
              "2": "2",
              "3": "4",
              "4": "0",
              "5": "8",
              "6": "5",
              "7": "6",
              "8": "3",
              "9": "7",
              "id": 4
          },
          {
              "0": "1",
              "1": "9",
              "2": "2",
              "3": "4",
              "4": "0",
              "5": "8",
              "6": "5",
              "7": "6",
              "8": "3",
              "9": "7",
              "id": 0
          },
          {
              "0": "1",
              "1": "9",
              "2": "2",
              "3": "4",
              "4": "0",
              "5": "8",
              "6": "5",
              "7": "6",
              "8": "3",
              "9": "7",
              "id": 2
          },
          {
              "0": "1",
              "1": "9",
              "2": "2",
              "3": "4",
              "4": "0",
              "5": "8",
              "6": "5",
              "7": "6",
              "8": "3",
              "9": "7",
              "id": 8
          },
          {
              "0": "1",
              "1": "9",
              "2": "2",
              "3": "4",
              "4": "0",
              "5": "8",
              "6": "5",
              "7": "6",
              "8": "3",
              "9": "7",
              "id": 3
          },
          {
              "0": "1",
              "1": "9",
              "2": "2",
              "3": "4",
              "4": "0",
              "5": "8",
              "6": "5",
              "7": "6",
              "8": "3",
              "9": "7",
              "id": 6
          },
          {
              "0": "1",
              "1": "9",
              "2": "2",
              "3": "4",
              "4": "0",
              "5": "8",
              "6": "5",
              "7": "6",
              "8": "3",
              "9": "7",
              "id": 7
          },
          {
              "0": "1",
              "1": "9",
              "2": "2",
              "3": "4",
              "4": "0",
              "5": "8",
              "6": "5",
              "7": "6",
              "8": "3",
              "9": "7",
              "id": 9
          },
          {
              "0": "1",
              "1": "9",
              "2": "2",
              "3": "4",
              "4": "0",
              "5": "8",
              "6": "5",
              "7": "6",
              "8": "3",
              "9": "7",
              "id": 5
          },
          {
              "0": "1",
              "1": "9",
              "2": "2",
              "3": "4",
              "4": "0",
              "5": "8",
              "6": "5",
              "7": "6",
              "8": "3",
              "9": "7",
              "id": 1
          }
      ],
      "Week": 3,
      "Channel": "ESPN/ABC",
      "Time": "8:15pm",
      "HomeTeam": "NYG",
      "Date": "09/26/22",
      "finalScore": {
          "HomeTeam": "A",
          "AwayTeam": "A"
      },
      "xValues": [
          6,
          7,
          5,
          8,
          1,
          2,
          4,
          9,
          0,
          3
      ],
      "AwayTeam": "DAL",
      "pot": "",
      "yValues": [
          4,
          0,
          2,
          8,
          3,
          6,
          7,
          9,
          5,
          1
      ]
  },
  {
      "yValues": [
          7,
          5,
          2,
          8,
          6,
          9,
          0,
          1,
          4,
          3
      ],
      "pot": "",
      "Week": 4,
      "Time": "8:15pm",
      "newSquareData": [
          {
              "0": "6",
              "1": "7",
              "2": "2",
              "3": "9",
              "4": "8",
              "5": "1",
              "6": "4",
              "7": "0",
              "8": "3",
              "9": "5",
              "id": 7
          },
          {
              "0": "6",
              "1": "7",
              "2": "2",
              "3": "9",
              "4": "8",
              "5": "1",
              "6": "4",
              "7": "0",
              "8": "3",
              "9": "5",
              "id": 5
          },
          {
              "0": "6",
              "1": "7",
              "2": "2",
              "3": "9",
              "4": "8",
              "5": "1",
              "6": "4",
              "7": "0",
              "8": "3",
              "9": "5",
              "id": 2
          },
          {
              "0": "6",
              "1": "7",
              "2": "2",
              "3": "9",
              "4": "8",
              "5": "1",
              "6": "4",
              "7": "0",
              "8": "3",
              "9": "5",
              "id": 8
          },
          {
              "0": "6",
              "1": "7",
              "2": "2",
              "3": "9",
              "4": "8",
              "5": "1",
              "6": "4",
              "7": "0",
              "8": "3",
              "9": "5",
              "id": 6
          },
          {
              "0": "6",
              "1": "7",
              "2": "2",
              "3": "9",
              "4": "8",
              "5": "1",
              "6": "4",
              "7": "0",
              "8": "3",
              "9": "5",
              "id": 9
          },
          {
              "0": "6",
              "1": "7",
              "2": "2",
              "3": "9",
              "4": "8",
              "5": "1",
              "6": "4",
              "7": "0",
              "8": "3",
              "9": "5",
              "id": 0
          },
          {
              "0": "6",
              "1": "7",
              "2": "2",
              "3": "9",
              "4": "8",
              "5": "1",
              "6": "4",
              "7": "0",
              "8": "3",
              "9": "5",
              "id": 1
          },
          {
              "0": "6",
              "1": "7",
              "2": "2",
              "3": "9",
              "4": "8",
              "5": "1",
              "6": "4",
              "7": "0",
              "8": "3",
              "9": "5",
              "id": 4
          },
          {
              "0": "6",
              "1": "7",
              "2": "2",
              "3": "9",
              "4": "8",
              "5": "1",
              "6": "4",
              "7": "0",
              "8": "3",
              "9": "5",
              "id": 3
          }
      ],
      "HomeTeam": "SF",
      "AwayTeam": "LAR",
      "Date": "10/03/22",
      "xValues": [
          8,
          1,
          0,
          2,
          3,
          6,
          5,
          4,
          7,
          9
      ],
      "finalScore": {
          "HomeTeam": "A",
          "AwayTeam": "A"
      },
      "Channel": "ESPN"
  },
  {
      "finalScore": {
          "HomeTeam": "A",
          "AwayTeam": "A"
      },
      "newSquareData": [
          {
              "0": "0",
              "1": "5",
              "2": "6",
              "3": "3",
              "4": "1",
              "5": "2",
              "6": "9",
              "7": "4",
              "8": "8",
              "9": "7",
              "id": 0
          },
          {
              "0": "0",
              "1": "5",
              "2": "6",
              "3": "3",
              "4": "1",
              "5": "2",
              "6": "9",
              "7": "4",
              "8": "8",
              "9": "7",
              "id": 4
          },
          {
              "0": "0",
              "1": "5",
              "2": "6",
              "3": "3",
              "4": "1",
              "5": "2",
              "6": "9",
              "7": "4",
              "8": "8",
              "9": "7",
              "id": 5
          },
          {
              "0": "0",
              "1": "5",
              "2": "6",
              "3": "3",
              "4": "1",
              "5": "2",
              "6": "9",
              "7": "4",
              "8": "8",
              "9": "7",
              "id": 3
          },
          {
              "0": "0",
              "1": "5",
              "2": "6",
              "3": "3",
              "4": "1",
              "5": "2",
              "6": "9",
              "7": "4",
              "8": "8",
              "9": "7",
              "id": 7
          },
          {
              "0": "0",
              "1": "5",
              "2": "6",
              "3": "3",
              "4": "1",
              "5": "2",
              "6": "9",
              "7": "4",
              "8": "8",
              "9": "7",
              "id": 1
          },
          {
              "0": "0",
              "1": "5",
              "2": "6",
              "3": "3",
              "4": "1",
              "5": "2",
              "6": "9",
              "7": "4",
              "8": "8",
              "9": "7",
              "id": 2
          },
          {
              "0": "0",
              "1": "5",
              "2": "6",
              "3": "3",
              "4": "1",
              "5": "2",
              "6": "9",
              "7": "4",
              "8": "8",
              "9": "7",
              "id": 9
          },
          {
              "0": "0",
              "1": "5",
              "2": "6",
              "3": "3",
              "4": "1",
              "5": "2",
              "6": "9",
              "7": "4",
              "8": "8",
              "9": "7",
              "id": 8
          },
          {
              "0": "0",
              "1": "5",
              "2": "6",
              "3": "3",
              "4": "1",
              "5": "2",
              "6": "9",
              "7": "4",
              "8": "8",
              "9": "7",
              "id": 6
          }
      ],
      "Time": "8:15pm",
      "AwayTeam": "LV",
      "Date": "10/10/22",
      "xValues": [
          2,
          6,
          4,
          9,
          1,
          7,
          5,
          3,
          8,
          0
      ],
      "Channel": "ESPN",
      "pot": "",
      "Week": 5,
      "yValues": [
          0,
          4,
          5,
          3,
          7,
          1,
          2,
          9,
          8,
          6
      ],
      "HomeTeam": "KC"
  },
  {
      "HomeTeam": "LAC",
      "Date": "10/17/22",
      "AwayTeam": "DEN",
      "Time": "8:15pm",
      "Week": 6,
      "finalScore": {
          "AwayTeam": "A",
          "HomeTeam": "A"
      },
      "Channel": "ESPN",
      "newSquareData": [
          {
              "0": "1",
              "1": "3",
              "2": "4",
              "3": "0",
              "4": "6",
              "5": "7",
              "6": "2",
              "7": "5",
              "8": "9",
              "9": "8",
              "id": 3
          },
          {
              "0": "1",
              "1": "3",
              "2": "4",
              "3": "0",
              "4": "6",
              "5": "7",
              "6": "2",
              "7": "5",
              "8": "9",
              "9": "8",
              "id": 0
          },
          {
              "0": "1",
              "1": "3",
              "2": "4",
              "3": "0",
              "4": "6",
              "5": "7",
              "6": "2",
              "7": "5",
              "8": "9",
              "9": "8",
              "id": 6
          },
          {
              "0": "1",
              "1": "3",
              "2": "4",
              "3": "0",
              "4": "6",
              "5": "7",
              "6": "2",
              "7": "5",
              "8": "9",
              "9": "8",
              "id": 1
          },
          {
              "0": "1",
              "1": "3",
              "2": "4",
              "3": "0",
              "4": "6",
              "5": "7",
              "6": "2",
              "7": "5",
              "8": "9",
              "9": "8",
              "id": 2
          },
          {
              "0": "1",
              "1": "3",
              "2": "4",
              "3": "0",
              "4": "6",
              "5": "7",
              "6": "2",
              "7": "5",
              "8": "9",
              "9": "8",
              "id": 7
          },
          {
              "0": "1",
              "1": "3",
              "2": "4",
              "3": "0",
              "4": "6",
              "5": "7",
              "6": "2",
              "7": "5",
              "8": "9",
              "9": "8",
              "id": 4
          },
          {
              "0": "1",
              "1": "3",
              "2": "4",
              "3": "0",
              "4": "6",
              "5": "7",
              "6": "2",
              "7": "5",
              "8": "9",
              "9": "8",
              "id": 5
          },
          {
              "0": "1",
              "1": "3",
              "2": "4",
              "3": "0",
              "4": "6",
              "5": "7",
              "6": "2",
              "7": "5",
              "8": "9",
              "9": "8",
              "id": 9
          },
          {
              "0": "1",
              "1": "3",
              "2": "4",
              "3": "0",
              "4": "6",
              "5": "7",
              "6": "2",
              "7": "5",
              "8": "9",
              "9": "8",
              "id": 8
          }
      ],
      "yValues": [
          3,
          0,
          6,
          1,
          2,
          7,
          4,
          5,
          9,
          8
      ],
      "xValues": [
          5,
          8,
          0,
          9,
          4,
          2,
          1,
          7,
          6,
          3
      ],
      "pot": ""
  },
  {
      "Channel": "ESPN",
      "xValues": [
          5,
          4,
          1,
          9,
          2,
          0,
          7,
          8,
          6,
          3
      ],
      "AwayTeam": "CHI",
      "finalScore": {
          "AwayTeam": "A",
          "HomeTeam": "A"
      },
      "pot": "",
      "yValues": [
          1,
          9,
          2,
          8,
          3,
          4,
          6,
          0,
          7,
          5
      ],
      "Week": 7,
      "Date": "10/24/22",
      "newSquareData": [
          {
              "0": "7",
              "1": "0",
              "2": "2",
              "3": "4",
              "4": "5",
              "5": "9",
              "6": "6",
              "7": "8",
              "8": "3",
              "9": "1",
              "id": 1
          },
          {
              "0": "7",
              "1": "0",
              "2": "2",
              "3": "4",
              "4": "5",
              "5": "9",
              "6": "6",
              "7": "8",
              "8": "3",
              "9": "1",
              "id": 9
          },
          {
              "0": "7",
              "1": "0",
              "2": "2",
              "3": "4",
              "4": "5",
              "5": "9",
              "6": "6",
              "7": "8",
              "8": "3",
              "9": "1",
              "id": 2
          },
          {
              "0": "7",
              "1": "0",
              "2": "2",
              "3": "4",
              "4": "5",
              "5": "9",
              "6": "6",
              "7": "8",
              "8": "3",
              "9": "1",
              "id": 8
          },
          {
              "0": "7",
              "1": "0",
              "2": "2",
              "3": "4",
              "4": "5",
              "5": "9",
              "6": "6",
              "7": "8",
              "8": "3",
              "9": "1",
              "id": 3
          },
          {
              "0": "7",
              "1": "0",
              "2": "2",
              "3": "4",
              "4": "5",
              "5": "9",
              "6": "6",
              "7": "8",
              "8": "3",
              "9": "1",
              "id": 4
          },
          {
              "0": "7",
              "1": "0",
              "2": "2",
              "3": "4",
              "4": "5",
              "5": "9",
              "6": "6",
              "7": "8",
              "8": "3",
              "9": "1",
              "id": 6
          },
          {
              "0": "7",
              "1": "0",
              "2": "2",
              "3": "4",
              "4": "5",
              "5": "9",
              "6": "6",
              "7": "8",
              "8": "3",
              "9": "1",
              "id": 0
          },
          {
              "0": "7",
              "1": "0",
              "2": "2",
              "3": "4",
              "4": "5",
              "5": "9",
              "6": "6",
              "7": "8",
              "8": "3",
              "9": "1",
              "id": 7
          },
          {
              "0": "7",
              "1": "0",
              "2": "2",
              "3": "4",
              "4": "5",
              "5": "9",
              "6": "6",
              "7": "8",
              "8": "3",
              "9": "1",
              "id": 5
          }
      ],
      "Time": "8:15pm",
      "HomeTeam": "NE"
  },
  {
      "Week": 8,
      "xValues": [
          8,
          9,
          5,
          0,
          1,
          6,
          3,
          7,
          2,
          4
      ],
      "Date": "10/31/22",
      "Time": "8:15pm",
      "finalScore": {
          "HomeTeam": "A",
          "AwayTeam": "A"
      },
      "pot": "",
      "HomeTeam": "CLE",
      "newSquareData": [
          {
              "0": "8",
              "1": "1",
              "2": "0",
              "3": "3",
              "4": "7",
              "5": "4",
              "6": "2",
              "7": "9",
              "8": "6",
              "9": "5",
              "id": 2
          },
          {
              "0": "8",
              "1": "1",
              "2": "0",
              "3": "3",
              "4": "7",
              "5": "4",
              "6": "2",
              "7": "9",
              "8": "6",
              "9": "5",
              "id": 1
          },
          {
              "0": "8",
              "1": "1",
              "2": "0",
              "3": "3",
              "4": "7",
              "5": "4",
              "6": "2",
              "7": "9",
              "8": "6",
              "9": "5",
              "id": 6
          },
          {
              "0": "8",
              "1": "1",
              "2": "0",
              "3": "3",
              "4": "7",
              "5": "4",
              "6": "2",
              "7": "9",
              "8": "6",
              "9": "5",
              "id": 3
          },
          {
              "0": "8",
              "1": "1",
              "2": "0",
              "3": "3",
              "4": "7",
              "5": "4",
              "6": "2",
              "7": "9",
              "8": "6",
              "9": "5",
              "id": 5
          },
          {
              "0": "8",
              "1": "1",
              "2": "0",
              "3": "3",
              "4": "7",
              "5": "4",
              "6": "2",
              "7": "9",
              "8": "6",
              "9": "5",
              "id": 9
          },
          {
              "0": "8",
              "1": "1",
              "2": "0",
              "3": "3",
              "4": "7",
              "5": "4",
              "6": "2",
              "7": "9",
              "8": "6",
              "9": "5",
              "id": 8
          },
          {
              "0": "8",
              "1": "1",
              "2": "0",
              "3": "3",
              "4": "7",
              "5": "4",
              "6": "2",
              "7": "9",
              "8": "6",
              "9": "5",
              "id": 4
          },
          {
              "0": "8",
              "1": "1",
              "2": "0",
              "3": "3",
              "4": "7",
              "5": "4",
              "6": "2",
              "7": "9",
              "8": "6",
              "9": "5",
              "id": 0
          },
          {
              "0": "8",
              "1": "1",
              "2": "0",
              "3": "3",
              "4": "7",
              "5": "4",
              "6": "2",
              "7": "9",
              "8": "6",
              "9": "5",
              "id": 7
          }
      ],
      "Channel": "ESPN",
      "AwayTeam": "CIN",
      "yValues": [
          2,
          1,
          6,
          3,
          5,
          9,
          8,
          4,
          0,
          7
      ]
  },
  {
      "AwayTeam": "BAL",
      "Time": "8:15pm",
      "HomeTeam": "NO",
      "finalScore": {
          "HomeTeam": "A",
          "AwayTeam": "A"
      },
      "Week": 9,
      "Date": "11/07/22",
      "xValues": [
          6,
          8,
          2,
          5,
          9,
          4,
          3,
          1,
          0,
          7
      ],
      "pot": "",
      "yValues": [
          7,
          5,
          4,
          3,
          2,
          1,
          0,
          6,
          8,
          9
      ],
      "newSquareData": [
          {
              "0": "6",
              "1": "5",
              "2": "4",
              "3": "3",
              "4": "2",
              "5": "1",
              "6": "7",
              "7": "0",
              "8": "8",
              "9": "9",
              "id": 7
          },
          {
              "0": "6",
              "1": "5",
              "2": "4",
              "3": "3",
              "4": "2",
              "5": "1",
              "6": "7",
              "7": "0",
              "8": "8",
              "9": "9",
              "id": 5
          },
          {
              "0": "6",
              "1": "5",
              "2": "4",
              "3": "3",
              "4": "2",
              "5": "1",
              "6": "7",
              "7": "0",
              "8": "8",
              "9": "9",
              "id": 4
          },
          {
              "0": "6",
              "1": "5",
              "2": "4",
              "3": "3",
              "4": "2",
              "5": "1",
              "6": "7",
              "7": "0",
              "8": "8",
              "9": "9",
              "id": 3
          },
          {
              "0": "6",
              "1": "5",
              "2": "4",
              "3": "3",
              "4": "2",
              "5": "1",
              "6": "7",
              "7": "0",
              "8": "8",
              "9": "9",
              "id": 2
          },
          {
              "0": "6",
              "1": "5",
              "2": "4",
              "3": "3",
              "4": "2",
              "5": "1",
              "6": "7",
              "7": "0",
              "8": "8",
              "9": "9",
              "id": 1
          },
          {
              "0": "6",
              "1": "5",
              "2": "4",
              "3": "3",
              "4": "2",
              "5": "1",
              "6": "7",
              "7": "0",
              "8": "8",
              "9": "9",
              "id": 0
          },
          {
              "0": "6",
              "1": "5",
              "2": "4",
              "3": "3",
              "4": "2",
              "5": "1",
              "6": "7",
              "7": "0",
              "8": "8",
              "9": "9",
              "id": 6
          },
          {
              "0": "6",
              "1": "5",
              "2": "4",
              "3": "3",
              "4": "2",
              "5": "1",
              "6": "7",
              "7": "0",
              "8": "8",
              "9": "9",
              "id": 8
          },
          {
              "0": "6",
              "1": "5",
              "2": "4",
              "3": "3",
              "4": "2",
              "5": "1",
              "6": "7",
              "7": "0",
              "8": "8",
              "9": "9",
              "id": 9
          }
      ],
      "Channel": "ESPN"
  },
  {
      "HomeTeam": "PHI",
      "newSquareData": [
          {
              "0": "5",
              "1": "3",
              "2": "1",
              "3": "9",
              "4": "4",
              "5": "8",
              "6": "0",
              "7": "2",
              "8": "6",
              "9": "7",
              "id": 6
          },
          {
              "0": "5",
              "1": "3",
              "2": "1",
              "3": "9",
              "4": "4",
              "5": "8",
              "6": "0",
              "7": "2",
              "8": "6",
              "9": "7",
              "id": 2
          },
          {
              "0": "5",
              "1": "3",
              "2": "1",
              "3": "9",
              "4": "4",
              "5": "8",
              "6": "0",
              "7": "2",
              "8": "6",
              "9": "7",
              "id": 7
          },
          {
              "0": "5",
              "1": "3",
              "2": "1",
              "3": "9",
              "4": "4",
              "5": "8",
              "6": "0",
              "7": "2",
              "8": "6",
              "9": "7",
              "id": 1
          },
          {
              "0": "5",
              "1": "3",
              "2": "1",
              "3": "9",
              "4": "4",
              "5": "8",
              "6": "0",
              "7": "2",
              "8": "6",
              "9": "7",
              "id": 4
          },
          {
              "0": "5",
              "1": "3",
              "2": "1",
              "3": "9",
              "4": "4",
              "5": "8",
              "6": "0",
              "7": "2",
              "8": "6",
              "9": "7",
              "id": 0
          },
          {
              "0": "5",
              "1": "3",
              "2": "1",
              "3": "9",
              "4": "4",
              "5": "8",
              "6": "0",
              "7": "2",
              "8": "6",
              "9": "7",
              "id": 8
          },
          {
              "0": "5",
              "1": "3",
              "2": "1",
              "3": "9",
              "4": "4",
              "5": "8",
              "6": "0",
              "7": "2",
              "8": "6",
              "9": "7",
              "id": 9
          },
          {
              "0": "5",
              "1": "3",
              "2": "1",
              "3": "9",
              "4": "4",
              "5": "8",
              "6": "0",
              "7": "2",
              "8": "6",
              "9": "7",
              "id": 5
          },
          {
              "0": "5",
              "1": "3",
              "2": "1",
              "3": "9",
              "4": "4",
              "5": "8",
              "6": "0",
              "7": "2",
              "8": "6",
              "9": "7",
              "id": 3
          }
      ],
      "xValues": [
          4,
          9,
          5,
          3,
          6,
          2,
          8,
          1,
          0,
          7
      ],
      "AwayTeam": "WAS",
      "Week": 10,
      "yValues": [
          6,
          2,
          7,
          1,
          4,
          0,
          8,
          9,
          5,
          3
      ],
      "pot": "",
      "Time": "8:15pm",
      "Date": "11/14/22",
      "finalScore": {
          "HomeTeam": "A",
          "AwayTeam": "A"
      },
      "Channel": "ESPN"
  },
  {
      "AwayTeam": "SF",
      "newSquareData": [
          {
              "0": "0",
              "1": "6",
              "2": "5",
              "3": "4",
              "4": "1",
              "5": "2",
              "6": "3",
              "7": "7",
              "8": "9",
              "9": "8",
              "id": 0
          },
          {
              "0": "0",
              "1": "6",
              "2": "5",
              "3": "4",
              "4": "1",
              "5": "2",
              "6": "3",
              "7": "7",
              "8": "9",
              "9": "8",
              "id": 4
          },
          {
              "0": "0",
              "1": "6",
              "2": "5",
              "3": "4",
              "4": "1",
              "5": "2",
              "6": "3",
              "7": "7",
              "8": "9",
              "9": "8",
              "id": 5
          },
          {
              "0": "0",
              "1": "6",
              "2": "5",
              "3": "4",
              "4": "1",
              "5": "2",
              "6": "3",
              "7": "7",
              "8": "9",
              "9": "8",
              "id": 6
          },
          {
              "0": "0",
              "1": "6",
              "2": "5",
              "3": "4",
              "4": "1",
              "5": "2",
              "6": "3",
              "7": "7",
              "8": "9",
              "9": "8",
              "id": 3
          },
          {
              "0": "0",
              "1": "6",
              "2": "5",
              "3": "4",
              "4": "1",
              "5": "2",
              "6": "3",
              "7": "7",
              "8": "9",
              "9": "8",
              "id": 2
          },
          {
              "0": "0",
              "1": "6",
              "2": "5",
              "3": "4",
              "4": "1",
              "5": "2",
              "6": "3",
              "7": "7",
              "8": "9",
              "9": "8",
              "id": 1
          },
          {
              "0": "0",
              "1": "6",
              "2": "5",
              "3": "4",
              "4": "1",
              "5": "2",
              "6": "3",
              "7": "7",
              "8": "9",
              "9": "8",
              "id": 7
          },
          {
              "0": "0",
              "1": "6",
              "2": "5",
              "3": "4",
              "4": "1",
              "5": "2",
              "6": "3",
              "7": "7",
              "8": "9",
              "9": "8",
              "id": 9
          },
          {
              "0": "0",
              "1": "6",
              "2": "5",
              "3": "4",
              "4": "1",
              "5": "2",
              "6": "3",
              "7": "7",
              "8": "9",
              "9": "8",
              "id": 8
          }
      ],
      "Channel": "ESPN",
      "pot": "",
      "xValues": [
          2,
          9,
          5,
          1,
          0,
          3,
          7,
          6,
          4,
          8
      ],
      "HomeTeam": " ARI",
      "finalScore": {
          "HomeTeam": "A",
          "AwayTeam": "A"
      },
      "Week": 11,
      "Date": "11/21/22",
      "yValues": [
          0,
          4,
          5,
          6,
          3,
          2,
          1,
          7,
          9,
          8
      ],
      "Time": "8:15pm"
  },
  {
      "xValues": [
          1,
          7,
          5,
          6,
          4,
          3,
          2,
          8,
          0,
          9
      ],
      "finalScore": {
          "HomeTeam": "A",
          "AwayTeam": "A"
      },
      "AwayTeam": "PIT",
      "Channel": "ESPN",
      "yValues": [
          8,
          7,
          3,
          2,
          1,
          5,
          9,
          0,
          4,
          6
      ],
      "HomeTeam": "IND",
      "pot": "",
      "Week": 12,
      "Date": "11/28/22",
      "Time": "8:15pm",
      "newSquareData": [
          {
              "0": "7",
              "1": "4",
              "2": "3",
              "3": "2",
              "4": "8",
              "5": "5",
              "6": "9",
              "7": "1",
              "8": "0",
              "9": "6",
              "id": 8
          },
          {
              "0": "7",
              "1": "4",
              "2": "3",
              "3": "2",
              "4": "8",
              "5": "5",
              "6": "9",
              "7": "1",
              "8": "0",
              "9": "6",
              "id": 7
          },
          {
              "0": "7",
              "1": "4",
              "2": "3",
              "3": "2",
              "4": "8",
              "5": "5",
              "6": "9",
              "7": "1",
              "8": "0",
              "9": "6",
              "id": 3
          },
          {
              "0": "7",
              "1": "4",
              "2": "3",
              "3": "2",
              "4": "8",
              "5": "5",
              "6": "9",
              "7": "1",
              "8": "0",
              "9": "6",
              "id": 2
          },
          {
              "0": "7",
              "1": "4",
              "2": "3",
              "3": "2",
              "4": "8",
              "5": "5",
              "6": "9",
              "7": "1",
              "8": "0",
              "9": "6",
              "id": 1
          },
          {
              "0": "7",
              "1": "4",
              "2": "3",
              "3": "2",
              "4": "8",
              "5": "5",
              "6": "9",
              "7": "1",
              "8": "0",
              "9": "6",
              "id": 5
          },
          {
              "0": "7",
              "1": "4",
              "2": "3",
              "3": "2",
              "4": "8",
              "5": "5",
              "6": "9",
              "7": "1",
              "8": "0",
              "9": "6",
              "id": 9
          },
          {
              "0": "7",
              "1": "4",
              "2": "3",
              "3": "2",
              "4": "8",
              "5": "5",
              "6": "9",
              "7": "1",
              "8": "0",
              "9": "6",
              "id": 0
          },
          {
              "0": "7",
              "1": "4",
              "2": "3",
              "3": "2",
              "4": "8",
              "5": "5",
              "6": "9",
              "7": "1",
              "8": "0",
              "9": "6",
              "id": 4
          },
          {
              "0": "7",
              "1": "4",
              "2": "3",
              "3": "2",
              "4": "8",
              "5": "5",
              "6": "9",
              "7": "1",
              "8": "0",
              "9": "6",
              "id": 6
          }
      ]
  },
  {
      "yValues": [
          9,
          4,
          3,
          1,
          5,
          8,
          2,
          7,
          6,
          0
      ],
      "newSquareData": [
          {
              "0": "9",
              "1": "3",
              "2": "6",
              "3": "2",
              "4": "1",
              "5": "4",
              "6": "8",
              "7": "7",
              "8": "5",
              "9": "0",
              "id": 9
          },
          {
              "0": "9",
              "1": "3",
              "2": "6",
              "3": "2",
              "4": "1",
              "5": "4",
              "6": "8",
              "7": "7",
              "8": "5",
              "9": "0",
              "id": 4
          },
          {
              "0": "9",
              "1": "3",
              "2": "6",
              "3": "2",
              "4": "1",
              "5": "4",
              "6": "8",
              "7": "7",
              "8": "5",
              "9": "0",
              "id": 3
          },
          {
              "0": "9",
              "1": "3",
              "2": "6",
              "3": "2",
              "4": "1",
              "5": "4",
              "6": "8",
              "7": "7",
              "8": "5",
              "9": "0",
              "id": 1
          },
          {
              "0": "9",
              "1": "3",
              "2": "6",
              "3": "2",
              "4": "1",
              "5": "4",
              "6": "8",
              "7": "7",
              "8": "5",
              "9": "0",
              "id": 5
          },
          {
              "0": "9",
              "1": "3",
              "2": "6",
              "3": "2",
              "4": "1",
              "5": "4",
              "6": "8",
              "7": "7",
              "8": "5",
              "9": "0",
              "id": 8
          },
          {
              "0": "9",
              "1": "3",
              "2": "6",
              "3": "2",
              "4": "1",
              "5": "4",
              "6": "8",
              "7": "7",
              "8": "5",
              "9": "0",
              "id": 2
          },
          {
              "0": "9",
              "1": "3",
              "2": "6",
              "3": "2",
              "4": "1",
              "5": "4",
              "6": "8",
              "7": "7",
              "8": "5",
              "9": "0",
              "id": 7
          },
          {
              "0": "9",
              "1": "3",
              "2": "6",
              "3": "2",
              "4": "1",
              "5": "4",
              "6": "8",
              "7": "7",
              "8": "5",
              "9": "0",
              "id": 6
          },
          {
              "0": "9",
              "1": "3",
              "2": "6",
              "3": "2",
              "4": "1",
              "5": "4",
              "6": "8",
              "7": "7",
              "8": "5",
              "9": "0",
              "id": 0
          }
      ],
      "Date": "12/05/22",
      "finalScore": {
          "AwayTeam": "A",
          "HomeTeam": "A"
      },
      "xValues": [
          5,
          4,
          8,
          7,
          9,
          6,
          1,
          3,
          2,
          0
      ],
      "Week": 13,
      "pot": "",
      "HomeTeam": "TB",
      "Channel": "ESPN",
      "AwayTeam": "NO",
      "Time": "8:15pm"
  },
  {
      "HomeTeam": "ARI",
      "pot": "",
      "xValues": [
          7,
          9,
          2,
          6,
          3,
          8,
          4,
          0,
          5,
          1
      ],
      "newSquareData": [
          {
              "0": "4",
              "1": "7",
              "2": "5",
              "3": "2",
              "4": "0",
              "5": "8",
              "6": "9",
              "7": "3",
              "8": "1",
              "9": "6",
              "id": 4
          },
          {
              "0": "4",
              "1": "7",
              "2": "5",
              "3": "2",
              "4": "0",
              "5": "8",
              "6": "9",
              "7": "3",
              "8": "1",
              "9": "6",
              "id": 8
          },
          {
              "0": "4",
              "1": "7",
              "2": "5",
              "3": "2",
              "4": "0",
              "5": "8",
              "6": "9",
              "7": "3",
              "8": "1",
              "9": "6",
              "id": 3
          },
          {
              "0": "4",
              "1": "7",
              "2": "5",
              "3": "2",
              "4": "0",
              "5": "8",
              "6": "9",
              "7": "3",
              "8": "1",
              "9": "6",
              "id": 7
          },
          {
              "0": "4",
              "1": "7",
              "2": "5",
              "3": "2",
              "4": "0",
              "5": "8",
              "6": "9",
              "7": "3",
              "8": "1",
              "9": "6",
              "id": 0
          },
          {
              "0": "4",
              "1": "7",
              "2": "5",
              "3": "2",
              "4": "0",
              "5": "8",
              "6": "9",
              "7": "3",
              "8": "1",
              "9": "6",
              "id": 2
          },
          {
              "0": "4",
              "1": "7",
              "2": "5",
              "3": "2",
              "4": "0",
              "5": "8",
              "6": "9",
              "7": "3",
              "8": "1",
              "9": "6",
              "id": 9
          },
          {
              "0": "4",
              "1": "7",
              "2": "5",
              "3": "2",
              "4": "0",
              "5": "8",
              "6": "9",
              "7": "3",
              "8": "1",
              "9": "6",
              "id": 1
          },
          {
              "0": "4",
              "1": "7",
              "2": "5",
              "3": "2",
              "4": "0",
              "5": "8",
              "6": "9",
              "7": "3",
              "8": "1",
              "9": "6",
              "id": 5
          },
          {
              "0": "4",
              "1": "7",
              "2": "5",
              "3": "2",
              "4": "0",
              "5": "8",
              "6": "9",
              "7": "3",
              "8": "1",
              "9": "6",
              "id": 6
          }
      ],
      "AwayTeam": "NE",
      "Week": 14,
      "yValues": [
          4,
          8,
          3,
          7,
          0,
          2,
          9,
          1,
          5,
          6
      ],
      "Date": "12/12/22",
      "Channel": "ESPN",
      "Time": "8:15pm",
      "finalScore": {
          "AwayTeam": "A",
          "HomeTeam": "A"
      }
  },
  {
      "Time": "8:15pm",
      "yValues": [
          1,
          4,
          5,
          9,
          3,
          2,
          7,
          8,
          0,
          6
      ],
      "Week": 15,
      "AwayTeam": "LAR",
      "Date": "12/19/22",
      "Channel": "ESPN/ABC",
      "pot": "",
      "HomeTeam": "GB",
      "newSquareData": [
          {
              "0": "8",
              "1": "0",
              "2": "5",
              "3": "4",
              "4": "1",
              "5": "2",
              "6": "9",
              "7": "6",
              "8": "7",
              "9": "3",
              "id": 1
          },
          {
              "0": "8",
              "1": "0",
              "2": "5",
              "3": "4",
              "4": "1",
              "5": "2",
              "6": "9",
              "7": "6",
              "8": "7",
              "9": "3",
              "id": 4
          },
          {
              "0": "8",
              "1": "0",
              "2": "5",
              "3": "4",
              "4": "1",
              "5": "2",
              "6": "9",
              "7": "6",
              "8": "7",
              "9": "3",
              "id": 5
          },
          {
              "0": "8",
              "1": "0",
              "2": "5",
              "3": "4",
              "4": "1",
              "5": "2",
              "6": "9",
              "7": "6",
              "8": "7",
              "9": "3",
              "id": 9
          },
          {
              "0": "8",
              "1": "0",
              "2": "5",
              "3": "4",
              "4": "1",
              "5": "2",
              "6": "9",
              "7": "6",
              "8": "7",
              "9": "3",
              "id": 3
          },
          {
              "0": "8",
              "1": "0",
              "2": "5",
              "3": "4",
              "4": "1",
              "5": "2",
              "6": "9",
              "7": "6",
              "8": "7",
              "9": "3",
              "id": 2
          },
          {
              "0": "8",
              "1": "0",
              "2": "5",
              "3": "4",
              "4": "1",
              "5": "2",
              "6": "9",
              "7": "6",
              "8": "7",
              "9": "3",
              "id": 7
          },
          {
              "0": "8",
              "1": "0",
              "2": "5",
              "3": "4",
              "4": "1",
              "5": "2",
              "6": "9",
              "7": "6",
              "8": "7",
              "9": "3",
              "id": 8
          },
          {
              "0": "8",
              "1": "0",
              "2": "5",
              "3": "4",
              "4": "1",
              "5": "2",
              "6": "9",
              "7": "6",
              "8": "7",
              "9": "3",
              "id": 0
          },
          {
              "0": "8",
              "1": "0",
              "2": "5",
              "3": "4",
              "4": "1",
              "5": "2",
              "6": "9",
              "7": "6",
              "8": "7",
              "9": "3",
              "id": 6
          }
      ],
      "finalScore": {
          "HomeTeam": "A",
          "AwayTeam": "A"
      },
      "xValues": [
          9,
          6,
          8,
          5,
          7,
          4,
          0,
          2,
          3,
          1
      ]
  },
  {
      "xValues": [
          8,
          0,
          6,
          7,
          3,
          9,
          1,
          5,
          4,
          2
      ],
      "AwayTeam": "LAC",
      "Week": 16,
      "Channel": "ESPN",
      "newSquareData": [
          {
              "0": "5",
              "1": "7",
              "2": "3",
              "3": "4",
              "4": "9",
              "5": "6",
              "6": "1",
              "7": "2",
              "8": "8",
              "9": "0",
              "id": 9
          },
          {
              "0": "5",
              "1": "7",
              "2": "3",
              "3": "4",
              "4": "9",
              "5": "6",
              "6": "1",
              "7": "2",
              "8": "8",
              "9": "0",
              "id": 6
          },
          {
              "0": "5",
              "1": "7",
              "2": "3",
              "3": "4",
              "4": "9",
              "5": "6",
              "6": "1",
              "7": "2",
              "8": "8",
              "9": "0",
              "id": 7
          },
          {
              "0": "5",
              "1": "7",
              "2": "3",
              "3": "4",
              "4": "9",
              "5": "6",
              "6": "1",
              "7": "2",
              "8": "8",
              "9": "0",
              "id": 2
          },
          {
              "0": "5",
              "1": "7",
              "2": "3",
              "3": "4",
              "4": "9",
              "5": "6",
              "6": "1",
              "7": "2",
              "8": "8",
              "9": "0",
              "id": 3
          },
          {
              "0": "5",
              "1": "7",
              "2": "3",
              "3": "4",
              "4": "9",
              "5": "6",
              "6": "1",
              "7": "2",
              "8": "8",
              "9": "0",
              "id": 0
          },
          {
              "0": "5",
              "1": "7",
              "2": "3",
              "3": "4",
              "4": "9",
              "5": "6",
              "6": "1",
              "7": "2",
              "8": "8",
              "9": "0",
              "id": 5
          },
          {
              "0": "5",
              "1": "7",
              "2": "3",
              "3": "4",
              "4": "9",
              "5": "6",
              "6": "1",
              "7": "2",
              "8": "8",
              "9": "0",
              "id": 1
          },
          {
              "0": "5",
              "1": "7",
              "2": "3",
              "3": "4",
              "4": "9",
              "5": "6",
              "6": "1",
              "7": "2",
              "8": "8",
              "9": "0",
              "id": 8
          },
          {
              "0": "5",
              "1": "7",
              "2": "3",
              "3": "4",
              "4": "9",
              "5": "6",
              "6": "1",
              "7": "2",
              "8": "8",
              "9": "0",
              "id": 4
          }
      ],
      "yValues": [
          9,
          6,
          7,
          2,
          3,
          0,
          5,
          1,
          8,
          4
      ],
      "finalScore": {
          "HomeTeam": "A",
          "AwayTeam": "A"
      },
      "Time": "8:15pm",
      "HomeTeam": "IND",
      "pot": "",
      "Date": "12/26/22"
  },
  {
      "finalScore": {
          "AwayTeam": "A",
          "HomeTeam": "A"
      },
      "HomeTeam": "CIN",
      "Week": 17,
      "yValues": [
          8,
          3,
          2,
          5,
          9,
          1,
          4,
          0,
          7,
          6
      ],
      "xValues": [
          0,
          6,
          4,
          8,
          1,
          3,
          7,
          5,
          9,
          2
      ],
      "Date": "01/02/23",
      "Channel": "ESPN/ABC",
      "pot": "",
      "AwayTeam": "BUF",
      "newSquareData": [
          {
              "0": "7",
              "1": "5",
              "2": "2",
              "3": "1",
              "4": "6",
              "5": "3",
              "6": "9",
              "7": "8",
              "8": "0",
              "9": "4",
              "id": 8
          },
          {
              "0": "7",
              "1": "5",
              "2": "2",
              "3": "1",
              "4": "6",
              "5": "3",
              "6": "9",
              "7": "8",
              "8": "0",
              "9": "4",
              "id": 3
          },
          {
              "0": "7",
              "1": "5",
              "2": "2",
              "3": "1",
              "4": "6",
              "5": "3",
              "6": "9",
              "7": "8",
              "8": "0",
              "9": "4",
              "id": 2
          },
          {
              "0": "7",
              "1": "5",
              "2": "2",
              "3": "1",
              "4": "6",
              "5": "3",
              "6": "9",
              "7": "8",
              "8": "0",
              "9": "4",
              "id": 5
          },
          {
              "0": "7",
              "1": "5",
              "2": "2",
              "3": "1",
              "4": "6",
              "5": "3",
              "6": "9",
              "7": "8",
              "8": "0",
              "9": "4",
              "id": 9
          },
          {
              "0": "7",
              "1": "5",
              "2": "2",
              "3": "1",
              "4": "6",
              "5": "3",
              "6": "9",
              "7": "8",
              "8": "0",
              "9": "4",
              "id": 1
          },
          {
              "0": "7",
              "1": "5",
              "2": "2",
              "3": "1",
              "4": "6",
              "5": "3",
              "6": "9",
              "7": "8",
              "8": "0",
              "9": "4",
              "id": 4
          },
          {
              "0": "7",
              "1": "5",
              "2": "2",
              "3": "1",
              "4": "6",
              "5": "3",
              "6": "9",
              "7": "8",
              "8": "0",
              "9": "4",
              "id": 0
          },
          {
              "0": "7",
              "1": "5",
              "2": "2",
              "3": "1",
              "4": "6",
              "5": "3",
              "6": "9",
              "7": "8",
              "8": "0",
              "9": "4",
              "id": 7
          },
          {
              "0": "7",
              "1": "5",
              "2": "2",
              "3": "1",
              "4": "6",
              "5": "3",
              "6": "9",
              "7": "8",
              "8": "0",
              "9": "4",
              "id": 6
          }
      ],
      "Time": "8:30pm"
  }
]
export let games3 = [
    {
      "AwayTeam": "DEN",
      "HomeTeam": "SEA",
      "Week": 1,
      "Date": "09/12/22",
      "xValues": [9,7,3,4,6,2,0,5,1,8],
      "yValues": [0,3,1,2,5,4,8,6,9,7],
      "newSquareData": [],
      "pot": "",
      "finalScore": {
          "HomeTeam": "N/A",
          "AwayTeam": "N/A"
        },
      "Time": "8:15pm",
      "Channel": "ESPN/ABC"
    },
    {
      "AwayTeam": "MIN",
      "HomeTeam": "PHI",
      "Week": 2,
      "Date": "09/19/22",
      "xValues": [0,1,2,3,4,5,6,7,8,9],
      "yValues": [0,1,2,3,4,5,6,7,8,9],
      "newSquareData": [],
      "pot": "",
      "finalScore": {
          "HomeTeam": "N/A",
          "AwayTeam": "N/A"
        },
      "Time": "8:30pm",
      "Channel": "ABC"
    },
    {
      "AwayTeam": "DAL",
      "HomeTeam": "NYG",
      "Week": 3,
      "Date": "09/26/22",
      "xValues": [0,1,2,3,4,5,6,7,8,9],
      "yValues": [0,1,2,3,4,5,6,7,8,9],
      "newSquareData": [],
      "pot": "",
      "finalScore": {
          "HomeTeam": "N/A",
          "AwayTeam": "N/A"
        },
      "Time": "8:15pm",
      "Channel": "ESPN/ABC"
    },
    {
      "AwayTeam": "LAR",
      "HomeTeam": "SF",
      "Week": 4,
      "Date": "10/03/22",
      "xValues": [0,1,2,3,4,5,6,7,8,9],
      "yValues": [0,1,2,3,4,5,6,7,8,9],
      "newSquareData": [],
      "pot": "",
      "finalScore": {
          "HomeTeam": "N/A",
          "AwayTeam": "N/A"
        },
      "Time": "8:15pm",
      "Channel": "ESPN"
    },
    {
      "AwayTeam": "LV",
      "HomeTeam": "KC",
      "Week": 5,
      "Date": "10/10/22",
      "xValues": [0,1,2,3,4,5,6,7,8,9],
      "yValues": [0,1,2,3,4,5,6,7,8,9],
      "newSquareData": [],
      "pot": "",
      "finalScore": {
          "HomeTeam": "N/A",
          "AwayTeam": "N/A"
        },
      "Time": "8:15pm",
      "Channel": "ESPN"
    },
    {
      "AwayTeam": "DEN",
      "HomeTeam": "LAC",
      "Week": 6,
      "Date": "10/17/22",
      "xValues": [0,1,2,3,4,5,6,7,8,9],
      "yValues": [0,1,2,3,4,5,6,7,8,9],
      "newSquareData": [],
      "pot": "",
      "finalScore": {
          "HomeTeam": "N/A",
          "AwayTeam": "N/A"
        },
      "Time": "8:15pm",
      "Channel": "ESPN"
    },
    {
      "AwayTeam": "CHI",
      "HomeTeam": "NE",
      "Week": 7,
      "Date": "10/24/22",
      "xValues": [0,1,2,3,4,5,6,7,8,9],
      "yValues": [0,1,2,3,4,5,6,7,8,9],
      "newSquareData": [],
      "pot": "",
      "finalScore": {
          "HomeTeam": "N/A",
          "AwayTeam": "N/A"
        },
      "Time": "8:15pm",
      "Channel": "ESPN"
    },
    {
      "AwayTeam": "CIN",
      "HomeTeam": "CLE",
      "Week": 8,
      "Date": "10/31/22",
      "xValues": [0,1,2,3,4,5,6,7,8,9],
      "yValues": [0,1,2,3,4,5,6,7,8,9],
      "newSquareData": [],
      "pot": "",
      "finalScore": {
          "HomeTeam": "N/A",
          "AwayTeam": "N/A"
        },
      "Time": "8:15pm",
      "Channel": "ESPN"
    },
    {
      "AwayTeam": "BAL",
      "HomeTeam": "NO",
      "Week": 9,
      "Date": "11/07/22",
      "xValues": [0,1,2,3,4,5,6,7,8,9],
      "yValues": [0,1,2,3,4,5,6,7,8,9],
      "newSquareData": [],
      "pot": "",
      "finalScore": {
          "HomeTeam": "N/A",
          "AwayTeam": "N/A"
        },
      "Time": "8:15pm",
      "Channel": "ESPN"
    },
    {
      "AwayTeam": "WAS",
      "HomeTeam": "PHI",
      "Week": 10,
      "Date": "11/14/22",
      "xValues": [0,1,2,3,4,5,6,7,8,9],
      "yValues": [0,1,2,3,4,5,6,7,8,9],
      "newSquareData": [],
      "pot": "",
      "finalScore": {
          "HomeTeam": "N/A",
          "AwayTeam": "N/A"
        },
      "Time": "8:15pm",
      "Channel": "ESPN"
    },
    {
      "AwayTeam": "SF",
      "HomeTeam": " ARI",
      "Week": 11,
      "Date": "11/21/22",
      "xValues": [0,1,2,3,4,5,6,7,8,9],
      "yValues": [0,1,2,3,4,5,6,7,8,9],
      "newSquareData": [],
      "pot": "",
      "finalScore": {
          "HomeTeam": "N/A",
          "AwayTeam": "N/A"
        },
      "Time": "8:15pm",
      "Channel": "ESPN"
    },
    {
      "AwayTeam": "PIT",
      "HomeTeam": "IND",
      "Week": 12,
      "Date": "11/28/22",
      "xValues": [0,1,2,3,4,5,6,7,8,9],
      "yValues": [0,1,2,3,4,5,6,7,8,9],
      "newSquareData": [],
      "pot": "",
      "finalScore": {
          "HomeTeam": "N/A",
          "AwayTeam": "N/A"
        },
      "Time": "8:15pm",
      "Channel": "ESPN"
    },
    {
      "AwayTeam": "NO",
      "HomeTeam": "TB",
      "Week": 13,
      "Date": "12/05/22",
      "xValues": [0,1,2,3,4,5,6,7,8,9],
      "yValues": [0,1,2,3,4,5,6,7,8,9],
      "newSquareData": [],
      "pot": "",
      "finalScore": {
          "HomeTeam": "N/A",
          "AwayTeam": "N/A"
        },
      "Time": "8:15pm",
      "Channel": "ESPN"
    },
    {
      "AwayTeam": "NE",
      "HomeTeam": "ARI",
      "Week": 14,
      "Date": "12/12/22",
      "xValues": [0,1,2,3,4,5,6,7,8,9],
      "yValues": [0,1,2,3,4,5,6,7,8,9],
      "newSquareData": [],
      "pot": "",
      "finalScore": {
          "HomeTeam": "N/A",
          "AwayTeam": "N/A"
        },
      "Time": "8:15pm",
      "Channel": "ESPN"
    },
    {
      "AwayTeam": "LAR",
      "HomeTeam": "GB",
      "Week": 15,
      "Date": "12/19/22",
      "xValues": [0,1,2,3,4,5,6,7,8,9],
      "yValues": [0,1,2,3,4,5,6,7,8,9],
      "newSquareData": [],
      "pot": "",
      "finalScore": {
          "HomeTeam": "N/A",
          "AwayTeam": "N/A"
        },
      "Time": "8:15pm",
      "Channel": "ESPN/ABC"
    },
    {
      "AwayTeam": "LAC",
      "HomeTeam": "IND",
      "Week": 16,
      "Date": "12/26/22",
      "xValues": [0,1,2,3,4,5,6,7,8,9],
      "yValues": [0,1,2,3,4,5,6,7,8,9],
      "newSquareData": [],
      "pot": "",
      "finalScore": {
          "HomeTeam": "N/A",
          "AwayTeam": "N/A"
        },
      "Time": "8:15pm",
      "Channel": "ESPN"
    },
    {
      "AwayTeam": "BUF",
      "HomeTeam": "CIN",
      "Week": 17,
      "Date": "01/02/23",
      "xValues": [0,1,2,3,4,5,6,7,8,9],
      "yValues": [0,1,2,3,4,5,6,7,8,9],
      "newSquareData": [],
      "pot": "",
      "finalScore": {
          "HomeTeam": "N/A",
          "AwayTeam": "N/A"
        },
      "Time": "8:30pm",
      "Channel": "ESPN/ABC"
    }
   ]
  
  export let games2021 = [
      {
        "Week": 10,
        "Date": "11/15/2021",
        "HomeTeam": "SF",
        "xValues": [0,1,2,3,4,5,6,7,8,9],
        "AwayTeam": "LA",
        "yValues": [0,1,2,3,4,5,6,7,8,9],
        "newSquareData": [],
        "pot": "",
        "finalScore": {
          "HomeTeam": 31,
          "AwayTeam": 10
        }
      },
      {
        "Week": 11,
        "Date": "11/22/2021",
        "HomeTeam": "TB",
        "xValues": [5, 2, 0, 7, 3, 6, 4, 9, 8, 1],
        "AwayTeam": "NYG",
        "yValues": [2, 9, 5, 8, 0, 3, 1, 6, 7, 4],
        "newSquareData": [],
        "pot": "",
        "finalScore": {
          "HomeTeam": "N/A",
          "AwayTeam": "N/A"
        }
      },
      {
        "Week": 12,
        "Date": "11/29/2021",
        "HomeTeam": "WAS",
        "xValues": [8, 1, 5, 2, 4, 3, 0, 6, 9, 7],
        "AwayTeam": "SEA",
        "yValues": [4, 1, 0, 6, 7, 2, 9, 3, 8, 5],
        "newSquareData": [],
        "pot": "",
        "finalScore": {
          "HomeTeam": "N/A",
          "AwayTeam": "N/A"
        }
      },
      {
        "Week": 13,
        "Date": "12/06/2021",
        "HomeTeam": "BUF",
        "xValues": [9, 1, 6, 4, 2, 3, 5, 0, 8, 7],
        "AwayTeam": "NE",
        "yValues": [1, 8, 4, 9, 6, 3, 2, 0, 7, 5],
        "newSquareData": [],
        "pot": "",
        "finalScore": {
          "HomeTeam": "N/A",
          "AwayTeam": "N/A"
        }
      },
      {
        "Week": 14,
        "Date": "12/13/2021",
        "HomeTeam": "LA",
        "xValues": [3, 4, 1, 7, 2, 8, 0, 6, 9, 5],
        "AwayTeam": "ARI",
        "yValues": [7, 8, 3, 4, 0, 5, 9, 1, 2, 6],
        "newSquareData": [],
        "pot": "",
        "finalScore": {
          "HomeTeam": "N/A",
          "AwayTeam": "N/A"
        }
      },
      {
        "Week": 15,
        "Date": "12/20/2021",
        "HomeTeam": "MIN",
        "xValues": [2, 3, 7, 4, 0, 5, 6, 1, 9, 8],
        "AwayTeam": "CHI",
        "yValues": [0, 3, 4, 8, 7, 5, 6, 1, 9, 2],
        "newSquareData": [],
        "pot": "",
        "finalScore": {
          "HomeTeam": "N/A",
          "AwayTeam": "N/A"
        }
      },
      {
        "Week": 16,
        "Date": "12/27/2021",
        "HomeTeam": "MIA",
        "xValues": [5, 9, 8, 6, 1, 2, 3, 0, 7, 4],
        "AwayTeam": "NO",
        "yValues": [0, 3, 5, 7, 8, 9, 2, 4, 1, 6],
        "newSquareData": [],
        "pot": "",
        "finalScore": {
          "HomeTeam": "N/A",
          "AwayTeam": "N/A"
        }
      },
      {
        "Week": 17,
        "Date": "01/03/2021",
        "HomeTeam": "PIT",
        "xValues": [9, 4, 1, 6, 2, 0, 3, 7, 5, 8],
        "AwayTeam": "CLE",
        "yValues": [9, 8, 2, 7, 1, 3, 0, 4, 5, 6],
        "newSquareData": [],
        "pot": "",
        "finalScore": {
          "HomeTeam": "N/A",
          "AwayTeam": "N/A"
        }
      }
    ];
    export const squares1 = [];

  
  export const squaresTemplate = 
  [
      {
        "id": 1,
        "0": "0",
        "1": "1",
        "2": "2",
        "3": "3",
        "4": "4",
        "5": "5",
        "6": "6",
        "7": "7",
        "8": "8",
        "9": "9",
      },
      {
        "id": 2,
        "0": "0",
        "1": "1",
        "2": "2",
        "3": "3",
        "4": "4",
        "5": "5",
        "6": "6",
        "7": "7",
        "8": "8",
        "9": "9",
      },
      {
        "id": 3,
        "0": "0",
        "1": "1",
        "2": "2",
        "3": "3",
        "4": "4",
        "5": "5",
        "6": "6",
        "7": "7",
        "8": "8",
        "9": "9",
      },
      {
        "id": 9,
        "0": "0",
        "1": "1",
        "2": "2",
        "3": "3",
        "4": "4",
        "5": "5",
        "6": "6",
        "7": "7",
        "8": "8",
        "9": "9",
      },
      {
        "id": 5,
        "0": "0",
        "1": "1",
        "2": "2",
        "3": "3",
        "4": "4",
        "5": "5",
        "6": "6",
        "7": "7",
        "8": "8",
        "9": "9",
      },
      {
        "id": 6,
        "0": "0",
        "1": "1",
        "2": "2",
        "3": "3",
        "4": "4",
        "5": "5",
        "6": "6",
        "7": "7",
        "8": "8",
        "9": "9",
      },
      {
        "id": 7,
        "0": "0",
        "1": "1",
        "2": "2",
        "3": "3",
        "4": "4",
        "5": "5",
        "6": "6",
        "7": "7",
        "8": "8",
        "9": "9",
      },
      {
        "id": 8,
        "0": "0",
        "1": "1",
        "2": "2",
        "3": "3",
        "4": "4",
        "5": "5",
        "6": "6",
        "7": "7",
        "8": "8",
        "9": "9",
      },
      {
        "id": 4,
        "0": "0",
        "1": "1",
        "2": "2",
        "3": "3",
        "4": "4",
        "5": "5",
        "6": "6",
        "7": "7",
        "8": "8",
        "9": "9",
      },
      {
        "id": 0,
        "0": "0",
        "1": "1",
        "2": "2",
        "3": "3",
        "4": "4",
        "5": "5",
        "6": "6",
        "7": "7",
        "8": "8",
        "9": "9",
      }
     ]

     export const squaresArray = [
      {
        "Squares": 1,
        "Name": "",
        "Row": 0
      },
      {
        "Squares": 2,
        "Name": "",
        "Row": 0
      },
      {
        "Squares": 3,
        "Name": "",
        "Row": 0
      },
      {
        "Squares": 4,
        "Name": "",
        "Row": 0
      },
      {
        "Squares": 5,
        "Name": "",
        "Row": 0
      },
      {
        "Squares": 6,
        "Name": "",
        "Row": 0
      },
      {
        "Squares": 7,
        "Name": "",
        "Row": 0
      },
      {
        "Squares": 8,
        "Name": "",
        "Row": 0
      },
      {
        "Squares": 9,
        "Name": "",
        "Row": 0
      },
      {
        "Squares": 10,
        "Name": "",
        "Row": 0
      },
      {
        "Squares": 11,
        "Name": "AMODIO",
        "Row": 1
      },
      {
        "Squares": 12,
        "Name": "ERIK",
        "Row": 1
      },
      {
        "Squares": 13,
        "Name": "ZIVIC",
        "Row": 1
      },
      {
        "Squares": 14,
        "Name": "LAURA",
        "Row": 1
      },
      {
        "Squares": 15,
        "Name": "",
        "Row": 1
      },
      {
        "Squares": 16,
        "Name": "JOE",
        "Row": 1
      },
      {
        "Squares": 17,
        "Name": "CARR",
        "Row": 1
      },
      {
        "Squares": 18,
        "Name": "RICK",
        "Row": 1
      },
      {
        "Squares": 19,
        "Name": "",
        "Row": 1
      },
      {
        "Squares": 20,
        "Name": "",
        "Row": 1
      },
      {
        "Squares": 21,
        "Name": "VANESSA",
        "Row": 2
      },
      {
        "Squares": 22,
        "Name": "",
        "Row": 2
      },
      {
        "Squares": 23,
        "Name": "BIGA",
        "Row": 2
      },
      {
        "Squares": 24,
        "Name": "MILES",
        "Row": 2
      },
      {
        "Squares": 25,
        "Name": "",
        "Row": 2
      },
      {
        "Squares": 26,
        "Name": "MARKO",
        "Row": 2
      },
      {
        "Squares": 27,
        "Name": "",
        "Row": 2
      },
      {
        "Squares": 28,
        "Name": "ETHRIDGE",
        "Row": 2
      },
      {
        "Squares": 29,
        "Name": "",
        "Row": 2
      },
      {
        "Squares": 30,
        "Name": "",
        "Row": 2
      },
      {
        "Squares": 31,
        "Name": "",
        "Row": 3
      },
      {
        "Squares": 32,
        "Name": "",
        "Row": 3
      },
      {
        "Squares": 33,
        "Name": "DEGREE",
        "Row": 3
      },
      {
        "Squares": 34,
        "Name": "",
        "Row": 3
      },
      {
        "Squares": 35,
        "Name": "",
        "Row": 3
      },
      {
        "Squares": 36,
        "Name": "ZEVA",
        "Row": 3
      },
      {
        "Squares": 37,
        "Name": "",
        "Row": 3
      },
      {
        "Squares": 38,
        "Name": "",
        "Row": 3
      },
      {
        "Squares": 39,
        "Name": "",
        "Row": 3
      },
      {
        "Squares": 40,
        "Name": "",
        "Row": 3
      },
      {
        "Squares": 41,
        "Name": "",
        "Row": 4
      },
      {
        "Squares": 42,
        "Name": "BELLE",
        "Row": 4
      },
      {
        "Squares": 43,
        "Name": "",
        "Row": 4
      },
      {
        "Squares": 44,
        "Name": "NOONAN",
        "Row": 4
      },
      {
        "Squares": 45,
        "Name": "",
        "Row": 4
      },
      {
        "Squares": 46,
        "Name": "",
        "Row": 4
      },
      {
        "Squares": 47,
        "Name": "RAY",
        "Row": 4
      },
      {
        "Squares": 48,
        "Name": "",
        "Row": 4
      },
      {
        "Squares": 49,
        "Name": "",
        "Row": 4
      },
      {
        "Squares": 50,
        "Name": "BOCK",
        "Row": 4
      },
      {
        "Squares": 51,
        "Name": "PAIGE",
        "Row": 5
      },
      {
        "Squares": 52,
        "Name": "",
        "Row": 5
      },
      {
        "Squares": 53,
        "Name": "",
        "Row": 5
      },
      {
        "Squares": 54,
        "Name": "",
        "Row": 5
      },
      {
        "Squares": 55,
        "Name": "SOMMERS",
        "Row": 5
      },
      {
        "Squares": 56,
        "Name": "",
        "Row": 5
      },
      {
        "Squares": 57,
        "Name": "",
        "Row": 5
      },
      {
        "Squares": 58,
        "Name": "",
        "Row": 5
      },
      {
        "Squares": 59,
        "Name": "",
        "Row": 5
      },
      {
        "Squares": 60,
        "Name": "",
        "Row": 5
      },
      {
        "Squares": 61,
        "Name": "",
        "Row": 6
      },
      {
        "Squares": 62,
        "Name": "",
        "Row": 6
      },
      {
        "Squares": 63,
        "Name": "",
        "Row": 6
      },
      {
        "Squares": 64,
        "Name": "",
        "Row": 6
      },
      {
        "Squares": 65,
        "Name": "",
        "Row": 6
      },
      {
        "Squares": 66,
        "Name": "",
        "Row": 6
      },
      {
        "Squares": 67,
        "Name": "",
        "Row": 6
      },
      {
        "Squares": 68,
        "Name": "",
        "Row": 6
      },
      {
        "Squares": 69,
        "Name": "TIDWELL",
        "Row": 6
      },
      {
        "Squares": 70,
        "Name": "JP",
        "Row": 6
      },
      {
        "Squares": 71,
        "Name": "",
        "Row": 7
      },
      {
        "Squares": 72,
        "Name": "",
        "Row": 7
      },
      {
        "Squares": 73,
        "Name": "",
        "Row": 7
      },
      {
        "Squares": 74,
        "Name": "",
        "Row": 7
      },
      {
        "Squares": 75,
        "Name": "",
        "Row": 7
      },
      {
        "Squares": 76,
        "Name": "",
        "Row": 7
      },
      {
        "Squares": 77,
        "Name": "CURTIS",
        "Row": 7
      },
      {
        "Squares": 78,
        "Name": "",
        "Row": 7
      },
      {
        "Squares": 79,
        "Name": "",
        "Row": 7
      },
      {
        "Squares": 80,
        "Name": "",
        "Row": 7
      },
      {
        "Squares": 81,
        "Name": "",
        "Row": 8
      },
      {
        "Squares": 82,
        "Name": "GRAY",
        "Row": 8
      },
      {
        "Squares": 83,
        "Name": "",
        "Row": 8
      },
      {
        "Squares": 84,
        "Name": "",
        "Row": 8
      },
      {
        "Squares": 85,
        "Name": "",
        "Row": 8
      },
      {
        "Squares": 86,
        "Name": "",
        "Row": 8
      },
      {
        "Squares": 87,
        "Name": "",
        "Row": 8
      },
      {
        "Squares": 88,
        "Name": "",
        "Row": 8
      },
      {
        "Squares": 89,
        "Name": "",
        "Row": 8
      },
      {
        "Squares": 90,
        "Name": "NANA",
        "Row": 8
      },
      {
        "Squares": 91,
        "Name": "",
        "Row": 9
      },
      {
        "Squares": 92,
        "Name": "",
        "Row": 9
      },
      {
        "Squares": 93,
        "Name": "",
        "Row": 9
      },
      {
        "Squares": 94,
        "Name": "",
        "Row": 9
      },
      {
        "Squares": 95,
        "Name": "",
        "Row": 9
      },
      {
        "Squares": 96,
        "Name": "",
        "Row": 9
      },
      {
        "Squares": 97,
        "Name": "",
        "Row": 9
      },
      {
        "Squares": 98,
        "Name": "",
        "Row": 9
      },
      {
        "Squares": 99,
        "Name": "",
        "Row": 9
      },
      {
        "Squares": 100,
        "Name": "",
        "Row": 9
      }
    ]